import { Component, OnInit, forwardRef, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { ROUTE_TRANSITION } from 'src/app/app.animation';
import { CommonService } from 'src/app/services/common.service';
import { UsersService } from 'src/app/services/users.service';
import { Router, NavigationEnd } from '@angular/router';
import { LeadSourceService } from 'src/app/services/lead-source.service';
import { LeadStatusService } from 'src/app/services/lead-status.service';
import { DatePipe } from '@angular/common';
import { MatSelectChange } from '@angular/material/select';
import { CatalogPriceRulesService } from 'src/app/services/catalog-price-rules.service';
import { Constant } from 'src/app/constant/constant';
import { ProductService } from 'src/app/services/product.service';
export interface ConditionFormComponentData {
  variable: any;
}

@Component({
  selector: 'calsoft-database-rule-condition-advanced',
  templateUrl: './database-rule-condition-advanced.component.html',
  styleUrls: ['./database-rule-condition-advanced.component.scss'],

  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatabaseRuleConditionAdvancedComponent),
      multi: true
    }
  ]
})
export class DatabaseRuleConditionAdvancedComponent implements ControlValueAccessor, OnDestroy, OnInit {

  sanitizedUrl: string = '';

  url = '';

  @Input()
  formLabel: string | number = "Condition";

  @Input()
  ruleId: any = 0;

  @Input() mainForm!: FormGroup;


  @Input()
  types: any = 0;

  @Output()
  remove: EventEmitter<void> = new EventEmitter<void>();

  _form: UntypedFormGroup;

  @Input() formGroup!: FormGroup;

  private _onChange: (
    value: ConditionFormComponentData | null | undefined
  ) => void;

  private _destroy$: Subject<void> = new Subject<void>();
  dropDownValues: any = [];
  selectedKey: any = 'default';
  resultDropdown: Object;
  attributeSet: any;
  category: any;

  firstFormGroup: UntypedFormGroup;
  protected _onDestroy = new Subject<void>();
  options: any;

  filteredcategoryTypeList: any;
  categoryTypeList: any;
  categoryControl: UntypedFormControl = new UntypedFormControl();
  categoryFilterControl: UntypedFormControl = new UntypedFormControl();
  type: any = 'text';
  countryTypeList: any;
  filteredcountryTypeList: any;
  countryControl: UntypedFormControl = new UntypedFormControl();
  countryFilterControl: UntypedFormControl = new UntypedFormControl();
  allCountryList: any;
  sortParam: string;
  constructor(private _fb: UntypedFormBuilder,
    private commonService: CommonService,
    private usersService: UsersService,
    private router: Router,
    private leadStatusService: LeadStatusService,
    private leadSourceService: LeadSourceService,
    public datePipe: DatePipe,
    private catalogPriceRulesService: CatalogPriceRulesService,
    private productService: ProductService,
  ) {
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  ngOnInit() {
    this._createFormGroup();
    //this._form =this.formGroup;

    console.log(this._form);

    this._setupObservables();
    this.categoryYFilter();
    this.getAllCategory();
    this.countrYFilter();
    this.getAllCountry();
    this.getCountryList();
    this.getCustomerList();
    this.customerYFilter();
    this.getAllCustomer();
    this.attributeYFilter();
    this.getLeadActivityTypeDownList();

    this.getLeadDropDownList();
    this.getLeadSourceDownList();
    this.getUserDropDownList();
    this.usertypeYFilter();

    this.getCatalogRules();
    console.log(this.types);

    if (this.types == 0) {
      this.attributeList = [
        { viewValue: "Lead Status", value: "statusName", type: "select" },
        { viewValue: "Lead Source", value: "sourceName", type: "select" },
        { viewValue: "Lead Owner", value: "ownerEmail", type: "select" },
        { viewValue: "City", value: "City_cust", type: "text" },
        { viewValue: "Country", value: "Country_cust", type: "text" },
        { viewValue: "ActivityCount", value: "activityCountOnLead", type: "text" },
        { viewValue: "Campaign Name", value: "adGroupName_configurableProduct", type: "text" },
        { viewValue: "Created Date", value: "createdDate", type: "date" },
        { viewValue: "Updated Date", value: "updatedDate", type: "date" },
        { viewValue: "Category", value: "category", type: "text" },
        { viewValue: "Product", value: "product", type: "text" },
        { viewValue: "FollowUp", value: "followUpDateTime", type: "date" },
      ]

    } else {

      this.attributeList = [
        { viewValue: "Lead Activity", value: "activityType", type: "select" },
        { viewValue: "Lead Out Come", value: "phoneCallOutcome", type: "select" },
        // { viewValue: "Status", value: "status", type: "select" },
        { viewValue: "Call Type", value: "callType", type: "select" },
        { viewValue: "Call Durations", value: "typeAndTime", type: "text" },
        { viewValue: "Created Date", value: "createdDate", type: "date" },
        { viewValue: "Updated Date", value: "updatedDate", type: "date" },
      ]


    }
    this.getAllAttributeList();

    let object =
      { viewValue: "Sale Amount", value: "saleAmount", type: "select" }


    if (this.router.url.includes('add-editorderSlab')) {
      this.fieldName.push(object);
    }
    if (this._form.value.fieldName === 'createdDate'
    ) {
      this._form.get('startDate')?.valueChanges.subscribe(() => this.updateFieldValue());

    }

    if (this._form.value.fieldName === 'updatedDate') {

      this._form.get('endDate')?.valueChanges.subscribe(() => this.updateFieldValue());
    }


    console.log(this._form);


  }


  updateFieldValue() {
    const start = this._form.get('startDate')?.value;
    const end = this._form.get('endDate')?.value;

    if (start && end) {
      const startStr = this.datePipe.transform(start, 'yyyy-MM-dd');
      const endStr = this.datePipe.transform(end, 'yyyy-MM-dd');

      this._form.get('fieldValue')?.setValue(`${startStr} ~ ${endStr}`);
    } else {
      this._form.get('fieldValue')?.setValue('');
    }
  }



  //activity

  activityTypeList: any = [
    { value: "Intersted", viewValue: "Intersted" },
    { value: "Not Intersted", viewValue: "Not Intersted" },
    { value: "Follow Up", viewValue: "Follow Up" },
    { value: "Phone Call", viewValue: "Phone Call" },
  ]


  getCountryList() {
    this.commonService.getCountryList().subscribe(
      data => {
        this.allCountryList = data;
        this.countryTypeList = data;
        this.filteredcountryTypeList = this.countryTypeList;

      }
    )
  }



  selectList: any = [
    { value: 1, viewValue: 'Active' },
    { value: 0, viewValue: 'InActive' },
  ]


  callTypeList: any = [
    { value: "Incoming call", viewValue: 'Incoming call' },
    { value: "Missed call", viewValue: 'Missed call' },
    { value: "Outgoing call", viewValue: 'Outgoing call' },
  ]



  getAllCountry() {
    this.filteredcountryTypeList = this.countryTypeList;
  }

  countrYFilter() {
    this.countryFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.countryFilter();
      });
  }

  protected countryFilter() {
    if (!this.countryTypeList) {
      return;
    }
    let search = this.countryFilterControl.value;
    if (!search) {
      this.filteredcountryTypeList = this.countryTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredcountryTypeList = this.countryTypeList.filter(country => country['countryName'].toLowerCase().indexOf(search) > -1)
  }





  private _filter(value: any): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }



  //category start search

  getCatalogRules() {
    this.catalogPriceRulesService.fetchAlldropdownValueForRule().subscribe(
      res => {




        this.categoryTypeList = res['category'];
        this.filteredcategoryTypeList = this.categoryTypeList;
      },
      error => {
      }
    )
  }

  filterCategory(value: any): string[] {
    var filterValue: any;
    if (value != '' && typeof value == 'string') {
      filterValue = value.toLowerCase();
    } else if (typeof value == "object") {
      if (value['categoryId'] != undefined) {
        filterValue = value['categoryName'];
        this.firstFormGroup.patchValue({ categoryId: value['categoryId'], categoryName: value['categoryName'] });
        filterValue = filterValue.toLowerCase();
      }
    } else {
      filterValue = "";
    }
    return this.categoryTypeList.filter(option => option.categoryName.toLowerCase().includes(filterValue));
  }


  getAllCategory() {
    this.filteredcategoryTypeList = this.categoryTypeList;
  }

  categoryYFilter() {
    this.categoryFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.categoryFilter();
      });
  }

  protected categoryFilter() {
    if (!this.categoryTypeList) {
      return;
    }
    // get the search keyword
    let search = this.categoryFilterControl.value;
    if (!search) {
      this.filteredcategoryTypeList = this.categoryTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the country
    this.filteredcategoryTypeList = this.categoryTypeList.filter(category => category['categoryName'].toLowerCase().indexOf(search) > -1)
  }


  ngOnDestroy() {
    if (this._destroy$ && !this._destroy$.closed) {
      this._destroy$.next();
      this._destroy$.complete();
    }
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  writeValue(value: ConditionFormComponentData): void {
    if (!value) {
      return;
    }

    this._form.patchValue(value);
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {

  }

  setDisabledState(isDisabled: boolean): void {
    // TODO: implement this method
    // throw new Error("setDisabledState not implemented");
  }

  private _createFormGroup() {
    this._form = this._fb.group({

      fieldName: [null, [Validators.required]],
      operators: [null, [Validators.required]],
      fieldValue: [null, [Validators.required]],
      startDate: [null, []],
      endDate: [null, []]
    });
  }

  private _setupObservables() {
    this._form.valueChanges.pipe(takeUntil(this._destroy$)).subscribe(value => {
      if (this._onChange) {
        this._onChange(value);
      }
    });
  }
  condition: any = [
    'AND', 'OR', 'IF'
  ]
  degreeTitleList = [];


  operators: any = [
    { viewValue: "Equals", value: "==" },
    { viewValue: "Not Equals", value: "!=" },
    { viewValue: "contains", value: "contains" },
    { viewValue: "Starts With", value: "startsWith" },
    { viewValue: "Ends With", value: "endsWith" },

  ]


  operatorsText: any = [
    { viewValue: "Equals", value: "==" },
    { viewValue: "Not Equals", value: "!=" },


  ]


  operatorsNuber: any = [
    { viewValue: "Equals", value: "==" },
    { viewValue: "Not Equals", value: "!=" },
    { viewValue: "Greater than", value: ">" },
    { viewValue: "Less than", value: "<" },
  ]
  operatorsDate: any = [
    { viewValue: "NOT BETWEEN", value: "NOT BETWEEN" },
    { viewValue: "BETWEEN", value: "BETWEEN" },
  ]

  operatorsSelect: any = [
    { viewValue: "=", value: "==" },
  ]

  paymentList: any = [
    { viewValue: "PayPal", value: "paypal_standard" },
    { viewValue: "Cash On Delivery", value: "Cash On Delivery" },

  ]


  fieldName: any = [
    { viewValue: "Lead Status", value: "statusName", type: "select" },
    { viewValue: "Lead Source", value: "sourceName", type: "select" },
    { viewValue: "Lead Activity", value: "activityType", type: "select" },
    { viewValue: "Lead Owner", value: "ownerEmail", type: "select" },

  ]

  attributeList: any = []


  List: any = [
    {
      degreeTitleList: [
        'Books', '5', '6',
      ]
    },
    {
      degreeTitleList: [
        'Books', '2', '3'
      ]
    },

  ];

  educationLevelChangeAction(i) {
    // this.dropDownValues = this.resultDropdown[i.value];
    this.selectedKey = i.value
    let indexUnassigned = this.fieldName.findIndex(x => x.value == i.value)
    this.type = this.fieldName[indexUnassigned].type
  }

  getFieldName(i) {
    if (this.ruleId > 0) {
      if (i != null) {
        let indexUnassigned = this.fieldName.findIndex(x => x.value == i)
        if (this.fieldName[indexUnassigned].type == 'text') {
          return true
        } else {
          return false
        }

      }
      else {
        return false
      }
    } else {

      if (this.selectedKey == 'default') {
        return true
      } else {
        let indexUnassigned = this.fieldName.findIndex(x => this.selectedKey = i)
        if (this.fieldName[indexUnassigned].type == 'text') {
          return true
        } else {
          return false
        }

      }
    }
  }



  ///customer 
  //Customer
  customerList: any;
  customerTypeList: any = [];
  filteredCustomerTypeList: any = [];
  customerControl: UntypedFormControl = new UntypedFormControl();
  customerFilterControl: UntypedFormControl = new UntypedFormControl();



  getCustomerList() {
    this.usersService.getCustomersList(2).subscribe(
      data => {
        this.customerList = data;
        this.customerTypeList = data;
        this.filteredCustomerTypeList = this.customerTypeList;

      }
    )
  }

  getAllCustomer() {
    this.filteredCustomerTypeList = this.customerTypeList;
  }

  customerYFilter() {
    this.customerFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.customerFilter();
      });
  }

  protected customerFilter() {
    if (!this.customerTypeList) {
      return;
    }
    // get the search keyword
    let search = this.customerFilterControl.value;
    if (!search) {
      this.filteredCustomerTypeList = this.customerTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredCustomerTypeList = this.customerTypeList.filter(Customer => Customer['email'].toLowerCase().indexOf(search) > -1)
  }


  //attribute

  attributeTypeList: any = [];
  filteredAttributeTypeList: any = [];
  attributeFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllAttributeList() {

    this.attributeTypeList = this.attributeList;
    this.filteredAttributeTypeList = this.attributeTypeList;
    this.attributeYFilter();

  }


  getAllAttribute() {
    this.filteredAttributeTypeList = this.attributeTypeList;
  }

  attributeYFilter() {
    this.attributeFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.attributeFilter();
      });
  }

  protected attributeFilter() {
    if (!this.attributeList) {
      return;
    }
    // get the search keyword
    let search = this.attributeFilterControl.value;
    if (!search) {
      this.filteredAttributeTypeList = this.attributeTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredAttributeTypeList = this.attributeTypeList.filter(Attribute => Attribute['viewValue'].toLowerCase().indexOf(search) > -1)
  }



  //lead status

  filtereddropdownTypeList: any;

  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();


  defaultLeadStatus: FormControl = new FormControl('');

  dropdownTypeList: any;
  dropdownList: any;


  getLeadDropDownList() {

    this.leadStatusService.getAllLeadStatusDropDown(0).subscribe(
      res => {
        this.dropdownList = res;
        this.dropdownTypeList = res;
        this.filtereddropdownTypeList = this.dropdownTypeList;
      },
      error => {
      })
  }


  typeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeidYFilter();
      });
  }


  protected typeidYFilter() {
    if (!this.dropdownTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereddropdownTypeList = this.dropdownTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereddropdownTypeList = this.dropdownTypeList.filter(user => user['statusName'].toLowerCase().indexOf(search) > -1)
  }

  getAlldropdowntype() {
    this.filtereddropdownTypeList = this.dropdownTypeList;
  }


  //leadSource

  filteredLeadSourceTypeList: any;

  LeadSourceTypeList: any;
  LeadSourceList: any;

  getLeadSourceDownList() {

    this.leadSourceService.getAllLeadSourceDropDown().subscribe(
      res => {
        this.LeadSourceList = res;
        this.LeadSourceTypeList = res;
        this.filteredLeadSourceTypeList = this.LeadSourceTypeList;
      },
      error => {
      })
  }


  LeadSourceYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeLeadSourceYFilter();
      });
  }


  protected typeLeadSourceYFilter() {
    if (!this.LeadSourceTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filteredLeadSourceTypeList = this.LeadSourceTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredLeadSourceTypeList = this.LeadSourceTypeList.filter(source => source['sourceName'].toLowerCase().indexOf(search) > -1)
  }

  getAllSourcedropdowntype() {
    this.filteredLeadSourceTypeList = this.LeadSourceTypeList;
  }
  selectedValues: any[] = [];
  filterColumnMultiSelect(value,) {

    let indexForloop = 0;

    let fieldValue = '';
    value.value.forEach(element => {

      if (indexForloop == 0) {
        fieldValue = element
      } else {
        fieldValue = fieldValue + "," + element
      }

      indexForloop++;

    });

    this._form.get("fieldValue").setValue(fieldValue);




  }



  //lead Owner

  defaultLeadOwner: FormControl = new FormControl('');

  userTypeList: any;
  userList: any;
  filtereduserTypeList: any;

  getUserDropDownList() {

    this.usersService.getAllUserStatusDropDown().subscribe(
      res => {
        this.userList = res;
        this.userTypeList = res;
        this.filtereduserTypeList = this.userTypeList;
      },
      error => {
      })
  }

  usertypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.usertypeidYFilter();
      });
  }


  protected usertypeidYFilter() {
    if (!this.userTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereduserTypeList = this.userTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereduserTypeList = this.userTypeList.filter(user => user['email'].toLowerCase().indexOf(search) > -1)
  }

  //ActivityType

  filteredActivityTypeList: any;

  LeadActivityTypeList: any;
  LeadActivityList: any;

  public LeadActivityFormFilterControl: UntypedFormControl = new UntypedFormControl();

  getLeadActivityTypeDownList() {

    this.leadSourceService.getAllActivityTypeDropDown().subscribe(
      res => {
        this.LeadActivityList = res;
        this.LeadActivityTypeList = res;
        this.filteredActivityTypeList = this.LeadActivityTypeList;
      },
      error => {
      })
  }


  LeadActivityTypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeLeadActivityTypeYFilter();
      });
  }


  protected typeLeadActivityTypeYFilter() {
    if (!this.LeadActivityTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filteredActivityTypeList = this.LeadActivityTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredActivityTypeList = this.LeadActivityTypeList.filter(source => source['activityType'].toLowerCase().indexOf(search) > -1)
  }

  getAllActivityTypedropdowntype() {
    this.filteredActivityTypeList = this.LeadActivityTypeList;
  }


  disableTyping(event: KeyboardEvent) {
    event.preventDefault();
  }

  onSelectionChange(event: MatSelectChange) {

    console.log("event", event.value);

    console.log(this._form.value, "form");


  }




  endDate() {

    const start = this._form.get('startDate')?.value;
    const end = this._form.get('endDate')?.value;

    if (start && end) {
      const startStr = this.datePipe.transform(start, 'yyyy-MM-dd');
      const endStr = this.datePipe.transform(end, 'yyyy-MM-dd');

      this._form.get('fieldValue')?.setValue(`${startStr} ~ ${endStr}`);
    }


    console.log(this._form);

  }

  onInput(event: Event): void {
    let inputElement = event.target as HTMLInputElement;
    let inputValue = inputElement.value.trim();

    if (inputValue.length > 1) {

      this.getProductList(inputValue);
    }


  }

  //product

  filteredProductdropdownTypeList: any;

  dropdownProductTypeList: any;
  productdropdownList: any;

  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  getProductList(param) {
    this.sortParam = 'entityId' + "," + Constant.Dsc;
    let search = null;
    if (param != null) {
      search = "name:*" + param + "*"
    }

    this.productService.getProductBySearch(search, this.page, this.size, this.sortParam,).subscribe(
      res => {
        this.productdropdownList = res['content'];
        this.dropdownProductTypeList = res['content'];
        this.filteredProductdropdownTypeList = this.dropdownProductTypeList;
      },
      error => {
      })
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }
}


